import { useState } from "react";
import moment from "moment";
import "./AccordionPenilaianKaryawan.css";

export default function AccordionPenilaianKaryawan({ data, tim }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="accordion-container-penilaian-karyawan">
      {data.map((item, index) => {
        const isOpen = openIndex === index;

        const mangkir = item?.alpha || 0;

        // setengah hari izin dibulatkan ke bawah (2,5 -> 2, 0,5 -> 0),
        // lalu dihitung sebagai hari izin
        const setengahHariIzin = Math.floor(
          item?.hariSetengahHariIzin ?? item?.setengahHariIzin ?? 0
        );
        const izin = (item?.hariIzin || 0) + setengahHariIzin;

        const totalSakit = item?.hariSakit || 0;
        const sakitDokter = item?.suratDokter || 0;
        const sakitRawatInap = item?.rawatInap || 0;

        const bulanKontrak = item?.bulanKontrak || 0;
        const totalApprove = item?.totalApprove || 0;
        const targetSS = Math.floor(bulanKontrak / 3);

        let nilaiSS = 0;

        if (targetSS <= 0) {
          nilaiSS = 100;
        } else if (totalApprove >= targetSS) {
          nilaiSS = 100;
        } else {
          nilaiSS = (totalApprove / targetSS) * 100;
        }

        let sakitTanpaDokter = totalSakit;
        if (sakitTanpaDokter < 0) sakitTanpaDokter = 0;

        const setengahHariSakitTanpaDokter =
          item?.hariSetengahHariSakitTanpaDokter || 0;

        const penguranganMangkir = mangkir * 50;

        // setengah hari izin sudah masuk ke variabel izin
        const penguranganIzin = izin * 17;

        const penguranganSakitDokter = sakitDokter * 1;
        const penguranganRawatInap = sakitRawatInap * 0.5;

        const penguranganSakitTanpaDokter =
          sakitTanpaDokter * 7 + (setengahHariSakitTanpaDokter * 7) / 2;

        const totalAbsen =
          (100 -
            penguranganSakitDokter -
            penguranganRawatInap -
            penguranganSakitTanpaDokter +
            (100 - penguranganMangkir) +
            (100 - penguranganIzin)) /
          3;

        const totalKabag =
          item.isSuggestionSystem && tim === 1
            ? (item.rajin +
                item.taat +
                item.hasil +
                item.sikap +
                item.pelanggaran +
                nilaiSS) /
              6
            : (item.rajin +
                item.taat +
                item.hasil +
                item.sikap +
                item.pelanggaran) /
              5;

        const rataRata = (totalAbsen * 70) / 100 + (totalKabag * 30) / 100;

        const getGrade = (nilai) => {
          if (nilai >= 96) return "A";
          if (nilai >= 81) return "B";
          if (nilai >= 61) return "C";
          if (nilai >= 41) return "D";
          return "E";
        };

        return (
          <div key={item._id} className="accordion-item-penilaian-karyawan">
            {/* HEADER */}
            <div
              className="accordion-header-penilaian-karyawan font-14-mobile-penilaian"
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <span>{item.name}</span>
              <span>{item.kepalaShift}</span>
              <span>
                {" "}
                {moment(item.timestamp)
                  .utcOffset(7)
                  .format("DD-MM-YYYY, HH:mm:ss")}
              </span>
              <span className={`arrow ${isOpen ? "open" : ""}`}>▼</span>
            </div>

            {/* CONTENT */}
            <div
              className={`accordion-content-penilaian-karyawan ${
                isOpen ? "open" : ""
              }`}
            >
              <div className="accordion-inner-penilaian-karyawan">
                {/* ABSEN */}
                <div className="section">
                  <div className="section-title font-14-mobile-penilaian">
                    Penilaian Absen
                  </div>

                  <div className="row">
                    <span>Bulan Kontrak</span>
                    <span>{bulanKontrak} Bulan</span>
                  </div>
                  <div className="row">
                    <span>Mangkir</span>
                    <span>{100 - penguranganMangkir}</span>
                  </div>
                  <div className="row">
                    <span>Sakit</span>
                    <span>
                      {100 -
                        penguranganSakitDokter -
                        penguranganSakitTanpaDokter -
                        penguranganRawatInap}
                    </span>
                  </div>
                  <div className="row">
                    <span>Izin</span>
                    <span>{100 - penguranganIzin}</span>
                  </div>

                  <div className="row total">
                    <span>Rata-rata</span>
                    <span>
                      {totalAbsen.toFixed(1)} ({getGrade(totalAbsen)})
                    </span>
                  </div>
                </div>

                {/* KABAG */}
                <div className="section">
                  <div className="section-title font-14-mobile-penilaian">
                    Penilaian Kabag
                  </div>

                  <div className="row">
                    <span>Rajin</span>
                    <span>{item.rajin}</span>
                  </div>
                  <div className="row">
                    <span>Taat</span>
                    <span>{item.taat}</span>
                  </div>
                  <div className="row">
                    <span>Hasil</span>
                    <span>{item.hasil}</span>
                  </div>
                  <div className="row">
                    <span>Sikap</span>
                    <span>{item.sikap}</span>
                  </div>
                  <div className="row">
                    <span>Pelanggaran</span>
                    <span>{item.pelanggaran}</span>
                  </div>
                  {tim === 1 ? (
                    <div className="row">
                      <span>Suggestion System</span>
                      <span>{nilaiSS}</span>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="row total">
                    <span>Rata-rata</span>
                    <span>
                      {totalKabag.toFixed(1)} ({getGrade(totalKabag)})
                    </span>
                  </div>
                </div>

                {/* FINAL */}
                <div className="section">
                  <div
                    className="section-title font-14-mobile-penilaian"
                    style={{ color: "transparent" }}
                  >
                    Hasil Akhir
                  </div>

                  <div className="row" style={{ fontWeight: "bold" }}>
                    <span>Nilai Akhir</span>
                    <span>
                      {rataRata.toFixed(1)} ({getGrade(rataRata)})
                    </span>
                  </div>
                  <div className="row total">
                    <span>Rekomendasi</span>
                    <span
                      style={
                        item.rekomendasi
                          ? { color: "green", fontWeight: "bold" }
                          : { color: "red", fontWeight: "bold" }
                      }
                    >
                      {item.rekomendasi ? "Diperpanjang" : "Tidak Diperpanjang"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
